var videoUtils = (function(){
	var videoPlayer = function (html) {
        var regexps = {
                youtube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.\-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig,
                vimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/,
                loom: /https?:\/\/(www\.)?loom.com\/(?:share|embed\/)?([0-9A-Za-z]+)/
            },
            convertVideo = function(html) {
                if (!html.match(/<iframe|<video/gi)) {
                    html = utils.stripTags(html);

                    var iframeStart = '<iframe class="card__video-iframe" src="',
                        iframeEnd = '" frameborder="0" allowfullscreen></iframe>';

                    if (html.match(regexps.youtube)) {
                        html = html.replace(regexps.youtube, iframeStart + '//www.youtube.com/embed/$1' + iframeEnd);
                    } 
                    
                    if (html.match(regexps.vimeo)) {
                        html = html.replace(regexps.vimeo, iframeStart + '//player.vimeo.com/video/$2' + iframeEnd);
                    }

                    if (html.match(regexps.loom)) {
                        html = html.replace(regexps.loom, iframeStart + '//www.loom.com/embed' + iframeEnd);
                    }
                }

                return html;
            };

        return convertVideo(html);
    },

    isVideo = function(html){
        var regexps = {
                youtube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.\-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig,
                vimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/,
                loom: /https?:\/\/(www\.)?loom.com\/(?:share|embed\/)?([0-9A-Za-z]+)/
            };

        return (html.match(regexps.youtube) || html.match(regexps.vimeo) || html.match(regexps.loom));
    };
    return {
        videoPlayer: videoPlayer,
        isVideo: isVideo
    };
})()

var imageUtils = (function(){
    var imageLoad = function(img, options){
        if (!img) return;
        if (img.src.match(/(gif|jpg|jpeg|tiff|png)$/)[0] != 'jpeg') return;

        var canvas = document.createElement('canvas'),
            ctx = canvas.getContext;
        if (!ctx) return;

        var def = new $.Deferred();
            settings = {
              canvas: true,
              maxWidth: 700, // Card has max width 700px
              maxHeight: $(window).height()
            };

        $.extend(settings, options);
        
        loadImage(
            img.src,
            function (cnvs) {
              if(cnvs.type === "error") {
                def.reject(img.src);
              } else {
                def.resolve(cnvs);
              }
            },
            settings
        );

        return def.promise();
    };
    return {
        imageLoad: imageLoad
    };
})()

var utils = (function(){
    var stripTags = function(input, allowed) {
        allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;

        return input.replace(tags, function ($0, $1) {
            return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
        });
    },
    trim = function(str) {
        return $.trim(str);
    };
    return {
        trim: trim,
        stripTags: stripTags
    };
})()

